module.exports = __webpack_public_path__ + "static/img/Cale.Hooker.045ad23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cale.Hooker.jpg
// module id = U+7L
// module chunks = 0